import {useDispatch} from "react-redux";
import {closeWindow} from "../../models/window/actions";

import { ReactComponent as CloseIcon } from './assets/images/close.svg'

import c from './assets/sass/sentModal.module.scss'

const SentModal = () => {
    const dispatch = useDispatch()

    const closeHandler = () => {
        dispatch(closeWindow())
    }

    return (
        <div className={c.component}>
            <div className={c.row}>
                <button className={c.close} onClick={closeHandler}>
                    <CloseIcon className={c.closeIcon}/>
                </button>
                <div className={c.title}>
                    Запрос отправлен
                </div>
                <div className={c.subTitle}>Ожидайте, с вами скоро свяжутся</div>
                <button className={c.online}>
                    Спасибо, жду!
                </button>
            </div>
        </div>
    )
}

export default SentModal
